import { all, put, takeLatest } from 'redux-saga/effects';
import {
    GET_SUSPICION_DASHBOARD,
    GET_SUSPICION_DASHBOARD_FAILURE,
    GET_SUSPICION_DASHBOARD_SUCCESS,
    GET_SUSPICION_MEMBERS,
    GET_SUSPICION_MEMBERS_FAILURE,
    GET_SUSPICION_MEMBERS_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetSuspicionDashboard({ payload }) {
    const { date, office_id, user_id } = payload || {};
    try {
        let url = `albait/dashboard/mock-locations/?`;
        if (date) url += `date=${date}&`;
        if (office_id) url += `office_id=${office_id}&`;
        if (user_id) url += `user_id=${user_id}&`;
        const response = yield defaultApi(url, 'GET');
        yield put({
            type: GET_SUSPICION_DASHBOARD_SUCCESS,
            payload: { data: response },
        });
    } catch (err) {
        yield put({
            type: GET_SUSPICION_DASHBOARD_FAILURE,
            payload: err,
        });
    }
}

export function* handleGetSuspicionMembers({ payload }) {
    const { office_id } = payload || {};
    try {
        const url = `albait/users/short/${office_id ? `?office_id=${office_id}` : ''}`;
        const response = yield defaultApi(url, 'GET');
        yield put({
            type: GET_SUSPICION_MEMBERS_SUCCESS,
            payload: { data: response },
        });
    } catch (err) {
        yield put({
            type: GET_SUSPICION_MEMBERS_FAILURE,
            payload: err,
        });
    }
}

export default function* root() {
    yield all([
        takeLatest(GET_SUSPICION_DASHBOARD, handleGetSuspicionDashboard),
        takeLatest(GET_SUSPICION_MEMBERS, handleGetSuspicionMembers),
    ]);
}
